"use client";

import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { Button } from "@oreme/ui";
import { ArrowRight, TriangleAlert } from "lucide-react";
import { useIsMobile } from "@oreme/ui/hooks/use-mobile";

function AlertBanner(): ReactElement {
  const t = useTranslations("global.AlertBanner");
  const isMobile = useIsMobile();
  return (
    <section className="h-10 px-4 flex flex-row justify-between items-center bg-red-600 text-white">
      <div className="flex flex-row gap-2 items-center min-w-0">
        <TriangleAlert strokeWidth={1} size={20} className="min-w-5" />
        <p className="p-0 m-0 text-xs font-semibold text-nowrap">
          {isMobile ? t("shortTitle") : t("title")}
        </p>
        <p
          className="hidden md:block p-0 m-0 text-xs truncate"
          title={t("description")}
        >
          {t("description")}
        </p>
      </div>
      <Button variant="secondary" size="xs" asChild>
        <a
          className="flex gap-2"
          href="https://framaforms.org/donnez-nous-votre-avis-1765901878"
          target="_blank"
        >
          {t("action")} <ArrowRight size={16} strokeWidth={1} />
        </a>
      </Button>
    </section>
  );
}

export { AlertBanner };
